export default "__VITE_ASSET__453aaaa4__"